module.exports = __webpack_public_path__ + "static/media/franco_mastantuono.fdb81a9f.jpg";